export default __webpack_public_path__ + "static/media/rick-flag.502ca76d.png";